export interface SignupFormContent {
  stepIndicator: string;
  title: string;
  subtitle: string;
}

export const signupFormContent: Record<'free' | 'paid', SignupFormContent> = {
  free: {
    stepIndicator: "",
    title: "Create your account",
    subtitle: "Get started with GreenLight today"
  },
  paid: {
    stepIndicator: "Step 1 of 2",
    title: "Create your account",
    subtitle: "You're signing up for the {planName} plan at ${price}/month"
  }
};
